import dayjs from 'dayjs';

import type { ScrapingJobStatus } from '../../types/types';

import type { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import { internalApiClient } from '@/shared/api-client/internal-api-client';

export async function createScrapingJob(data: {
  platform: SOURCE_PLATFORM_TYPE;
  keyword: string;
  itemsPerDay: number;
  startDateToScrape?: Date;
  endDateToScrape?: Date;
  runMode?: 'BOTH' | 'ONETIME' | 'PERIODIC';
  memo?: string;
}) {
  return await internalApiClient.post<{
    documentCreatedAt: number;
    ownerName: string;
    platform: string;
    query: string;
    status: ScrapingJobStatus;
    scrapedItemCount: number;
    startDate: string;
    endDate: string;
    temporalScheduleId: string;
    _id: string;
    memo?: string;
  }>('social-post-scraping-jobs', {
    json: {
      platform: data.platform,
      query: data.keyword,
      ...(data.startDateToScrape && {
        startDateStr: dayjs(data.startDateToScrape).format('YYYY-MM-DD'),
      }),
      ...(data.endDateToScrape && {
        endDateStr: dayjs(data.endDateToScrape).format('YYYY-MM-DD'),
      }),
      itemsPerDay: data.itemsPerDay,
      ...(data.runMode && { runMode: data.runMode }),
      ...(data.memo && { memo: data.memo }),
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
